module.exports = __webpack_public_path__ + "media/images/medal-bronze-cc411907208fc0760afaeb79964f1fb6.svg";